export function isAlitheiaQuestionsPageVisible(user: any) {
    return user?.walkthrough?.userData?.phase1?.amplifyVulPrequalify === true;
}

export function isEmcEligible(user: any, isNeedToCheckIncomeStr = true) {
    return (
        user?.quote?.user_selected_perm_carrier === 'EMC National Life' || testCriteria(user, isNeedToCheckIncomeStr)
    );
}

function testCriteria(user: any, isNeedToCheckIncomeStr = true) {
    const userData = user?.walkthrough?.userData;

    const incomeStr = userData?.phase1?.annualIndividualIncome?.toString();
    const emailLower = userData?.email?.toLowerCase();

    const incomeConditionMet = isNeedToCheckIncomeStr ? incomeStr === '12683958' || incomeStr === '4157186' : true;
    const emailConditionMet =
        process.env.NEXT_PUBLIC_STAGE !== 'prod' ? true : emailLower?.includes('@getamplifylife.com');

    return incomeConditionMet && emailConditionMet;
}
